import { useState } from 'react';
import { faqs } from '@/mocks/movies';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">常见问题</h2>
            <p className="text-xs md:text-sm text-foreground-400 mt-1">关于快看影视的常见问题解答</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                  aria-expanded={openIndex === index}
                >
                  <span className="text-sm md:text-base font-medium text-foreground-100 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center rounded-full border border-background-300 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line text-sm text-foreground-300"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-60 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-400 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}